/**
 * @generated SignedSource<<16f13a70224e7bcfd9e4310e91f1f669>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItem_navItem$data = {
  readonly eventName: string | null;
  readonly href: string | null;
  readonly interactionType: string | null;
  readonly newWindow: boolean | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NavItemVATReportLink_navItem" | "NavItem_navItem">;
  readonly " $fragmentType": "NavExpandingAreaItem_navItem";
};
export type NavExpandingAreaItem_navItem$key = {
  readonly " $data"?: NavExpandingAreaItem_navItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_navItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItem_navItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_navItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemVATReportLink_navItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newWindow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interactionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};

(node as any).hash = "fb2512a7ac93a98356f0290d27aa3181";

export default node;
